module.exports = __webpack_public_path__ + "a719099889028ad42175bb150f5d887c.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/create-label/create-label.html
// module id = 2055
// module chunks = 0